export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/internet_technology.57c9356.svg";